import { ObjectTypes } from '@diligentcorp/rc-service-object-mapping';
import { GetIssueRelationshipsResponseDto } from '@issuemanager/api-client';
import {
  getRelationshipLinkBaseUrl,
  getRelationshipObjectUrl,
} from '@issuemanager/apps/client/utils';
import { Link, TableCell } from '@mui/material';
import { JSX, useMemo } from 'react';

type RelationshipLinkProps = {
  relationship: GetIssueRelationshipsResponseDto;
};

export function RelationshipLink({
  relationship,
}: RelationshipLinkProps): JSX.Element {
  const relationshipLinkBaseUrl = getRelationshipLinkBaseUrl();
  const hasBaseUrl = Boolean(relationshipLinkBaseUrl);

  const displayId = useMemo(
    () =>
      (relationship.relatedObject.type === ObjectTypes.AUDIT ||
        relationship.relatedObject.type === ObjectTypes.CONTROL_ASSESSMENT) &&
      relationship.relatedObject.hroid
        ? relationship.relatedObject.hroid
        : relationship.relatedObject.id,
    [
      relationship.relatedObject.hroid,
      relationship.relatedObject.id,
      relationship.relatedObject.type,
    ],
  );

  const url = useMemo(
    () =>
      getRelationshipObjectUrl({
        objectType: relationship.relatedObject.type,
        objectId: relationship.relatedObject.id,
        baseUrl: relationshipLinkBaseUrl!,
        hroid: relationship.relatedObject.hroid,
        service: relationship.relatedObject.service,
      }),
    [relationship, relationshipLinkBaseUrl],
  );

  return (
    <TableCell>
      {hasBaseUrl && url ? (
        <Link
          href={url}
          target='_blank'
          rel='noopener noreferrer'
          underline='hover'
          color='primary'
          data-testid={`relationship-id-link-${relationship.id}`}
        >
          {displayId}
        </Link>
      ) : (
        displayId
      )}
    </TableCell>
  );
}
